/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/unassigned_orders`

const allocation_unassigned_order = {
  namespaced: true,
  actions: {
    /**
     * 配車計画 受注一覧
     * @param commit
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { target_date }) {
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
export default allocation_unassigned_order
